'use strict';

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

module.exports = ownerDocument;
